import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import services from '../services/index'
import FullPage from './Fullpage';
//import Private from './Private'

const PrivateRoutes = ({ allow: allow, component: Component, ...rest }) => {

    const user = services.storage.getUser();
    const role = user?.role?.displayName;

    return ( allow===undefined || allow.includes(role)) ? (
        <Route  {...rest} render={props => (
            services.storage.get('isAuthenticated') && !services.storage.get('isUserCompany')
            ? <FullPage><Component {...props} /></FullPage>
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )} />
    ) : <Redirect to={"/home"}/>
}

export default PrivateRoutes